/**
 * useSupportAccess — lo que el USUARIO tiene que ver del acceso de soporte:
 * una solicitud de permiso pendiente, una sesión de soporte en curso o que el
 * soporte acaba de salir.
 *
 * Por qué consulta cada 5 s: el backend es WSGI sin canal de tiempo real, y la
 * consulta es además la PRESENCIA — el admin solo puede pedir permiso a quien
 * la tiene abierta. Solo con la pestaña visible: una pestaña olvidada no cuenta
 * como «conectado», y nadie vería el modal en ella.
 *
 * Apagada para el agente que está dentro de una cuenta (su navegador ejecuta
 * el SPA «como» el cliente) y para los admins: a un admin no se le pide
 * permiso. El backend devuelve vacío en esos dos casos de todos modos.
 */
import { useQuery } from '@tanstack/react-query';

import { getCurrentSupportAccess } from '@/api/supportAccessService';
import { useAuth } from '@/lib/AuthContext';

export const SUPPORT_ACCESS_QUERY_KEY = ['supportAccess', 'current'];
export const SUPPORT_ACCESS_POLL_MS = 5000;

export function useSupportAccess() {
  const { user, isAuthenticated, impersonation } = useAuth();
  const enabled = !!(
    isAuthenticated
    && user?.supportAccessEnabled
    && !impersonation?.active
    && !user?.is_staff
  );

  return useQuery({
    queryKey: SUPPORT_ACCESS_QUERY_KEY,
    queryFn: getCurrentSupportAccess,
    enabled,
    refetchInterval: SUPPORT_ACCESS_POLL_MS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    // Una consulta fallida no reintenta en bucle: la siguiente llega en 5 s.
    retry: false,
    staleTime: 0,
  });
}
